
<template>
  <div class="PacienteDetalleConsentimientos">
    <v-card
      outlined
      :disabled="cargando"
      :loading="cargando"
    >
      <v-card-title>
        Consentimientos
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Buscar"
          hide-details
        />
      </v-card-title>
      <v-data-table
        class="upper"
        :headers="headers"
        :items="consentimientos"
        :search="search"
        :loading="cargando"
        loading-text="Cargando..."
      >
        <template v-slot:item.fecha="{ item }">
          {{_doDiaMesHoras(item.fecha)}}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            icon
            v-if="item.evidencia_cns"
            @click="evidenciaImg = item.evidencia_cns;showDialogEvidencia=true;"
          >
            <v-icon>gesture</v-icon>
          </v-btn>
          <v-btn
            icon
            v-if="item.adicional_cns"
            :href="$raiz+'uploads/consentimientos/'+item.adicional_cns"
            target="_blank"
          >
            <v-icon>post_add</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
      width="400"
      v-model="showDialogEvidencia"
    >
      <v-card>
        <v-card-title v-text="'Firma del paciente'" />
        <v-img :src="evidenciaImg"></v-img>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            v-text="'Cerrar'"
            @click="showDialogEvidencia=false"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import forms from "@/mixins/forms.js";
import dates from "@/mixins/dates.js";
export default {
  name: "PacienteDetalleConsentimientos",
  props: {
    id: [String, Number],
  },
  mixins: [forms, dates],
  data() {
    return {
      search: "",
      headers: [
        { text: "Fecha", value: "fecha" },
        { text: "Generado por", value: "medico" },
        { text: "Estatus", value: "estatus" },
        { text: "", value: "actions", align: "end" },
      ],
      showDialogEvidencia: false,
      paciente: null,
      consentimientos: [],
      evidenciaImg: null,
    };
  },
  methods: {
    _getConsentimientos() {
      if (this.id) {
        this._getThings(
          "consentimientos/paciente/" + this.id,
          "consentimientos"
        );
      }
    },
  },
  created() {
    this.paciente = this.id;
    this._getConsentimientos();
  },
  watch: {
    id() {
      this.paciente = this.id;
      this._getConsentimientos();
    },
    showDialogEvidencia(a) {
      if (!a) this.evidenciaImg = false;
    },
  },
};
</script>

